


























































































































import {
  computed, defineComponent, PropType, reactive, ref,
} from '@vue/composition-api';
import { useI18N } from '@a/composables/use-vue-i18n';
import { useConfigurationApi } from '@a/plugins/configuration';
import { useTracking } from '@a/plugins/tracking';
import { TrackingEventTypes } from '@a/plugins/tracking/types/tracking';
import { useStore } from '@a/store';
import { OrderWidgetConfigurationItem } from '@a/store/landingpage/types';
import { ProductServerLocation } from '@a/store/product/types';
import RegionSwitcherModal from '../../footer/RegionSwitcherModal.vue';
import DropdownInputElement from '../../ui/form/elements/DropdownInputElement.vue';
import { DropdownGroup, DropDownItem } from '@c/ui/select/types/dropdownItem';
import {
  getDefaultLocationDropdownItem,
  getFormattedRamByUnitsAndLocale,
  groupOrderConfigurationByRegion,
  hasOrderConfigurationActiveLocations,
} from './OrderWidgetFeatures';

export default defineComponent({
  name: 'OrderWidgetBox',
  components: { DropdownInputElement, RegionSwitcherModal },
  props: {
    widgetItem: {
      required: true,
      type: Object as PropType<OrderWidgetConfigurationItem>,
    },
    widgetIndex: {
      required: false,
      default: -1,
      type: Number,
    },
    widgetOpen: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  setup: (props) => {
    const i18n = useI18N();
    const tracking = useTracking();
    const store = useStore();
    const configurationApi = useConfigurationApi();
    const orderWidgetForm = ref<HTMLFormElement>(null);
    const { units, duration } = props.widgetItem;

    const soldOutTitle = i18n.t('payment:checkout.sold_out');

    const state = reactive({
      showRegionModal: false,
      selectedItem: getDefaultLocationDropdownItem(
        {
          region: configurationApi.data.routes.regionPrefix,
          locale: configurationApi.data.routes.localePrefix,
        },
        props.widgetItem.locations,
        soldOutTitle,
      ) as DropDownItem<number>,
      currentLocation: computed(
        (): ProductServerLocation => props.widgetItem.locations.find(
          (location: ProductServerLocation) => location.key === state.selectedItem.value,
        ),
      ),
      dropdownItems: computed((): DropdownGroup<number>[] => groupOrderConfigurationByRegion(
        props.widgetItem,
        state.currentLocation,
        {
          soldOutTitle: i18n.t('payment:checkout.sold_out'),
          currentServerRegionTitle: i18n.t('landingpage:orderwidget.group.current_server_region'),
          otherServerRegionTitle: i18n.t('landingpage:orderwidget.group.other_server_region'),
        },
      )),
      hasOtherLocations: computed((): boolean => hasOrderConfigurationActiveLocations(
        groupOrderConfigurationByRegion(props.widgetItem, state.currentLocation, soldOutTitle),
      )),
    });

    const onWidgetSubmit = () => {
      state.showRegionModal = state.currentLocation.switchRegion && store.getters['auth/customer'] !== null;

      tracking.track({
        event: TrackingEventTypes.LP_SLOTBOX_SB_LOCATION,
        data: {
          type: 'button',
          target: state.currentLocation.orderUrl ?? undefined,
          configuration: {
            units,
            duration,
          },
        },
      });

      if (!state.showRegionModal) {
        orderWidgetForm.value.submit();
      }
    };

    /**
     * callback which is executed when the customer gets the region
     * modal and accepts it (only happends for location of the other region)
     */
    const onRegionSwitcherConfirm = () : void => {
      state.showRegionModal = false;

      if (!state.selectedItem) {
        throw new Error('No item is selected!');
      }

      orderWidgetForm.value.submit();
    };

    return {
      units,
      duration,
      orderWidgetForm,
      state,
      i18n,
      getFormattedRamByUnitsAndLocale,
      onRegionSwitcherConfirm,
      onWidgetSubmit,
    };
  },
});
